"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = exports.OConfig = exports.IConfig = void 0;
const mongoose_1 = __importDefault(require("mongoose"));
const runtypes_1 = require("runtypes");
exports.IConfig = (0, runtypes_1.Record)({
    maxRequestsPerMember: runtypes_1.Number.withConstraint((val) => val > 0),
    displayOrdering: (0, runtypes_1.Array)((0, runtypes_1.Record)({
        group: (0, runtypes_1.Optional)(runtypes_1.String),
        consultants: (0, runtypes_1.Array)((0, runtypes_1.Optional)(runtypes_1.String)),
    })),
});
exports.OConfig = exports.IConfig.extend({
    id: runtypes_1.String,
});
exports.ConfigSchema = new mongoose_1.default.Schema({
    maxRequestsPerMember: { type: Number, default: 10, required: true },
    displayOrdering: [{
            group: {
                type: mongoose_1.default.Schema.Types.ObjectId,
                ref: "Group",
            },
            consultants: [{
                    type: mongoose_1.default.Schema.Types.ObjectId,
                    ref: "Consultant",
                }],
        }],
});
